



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'SearchBar',
})
export default class SearchBar extends Vue {
    @Prop(String) private value: string;

    private internalValue: string = '';

    private created(): void {
        this.internalValue = this.value;
    }

    private search(): void {
        this.$emit('search', this.internalValue);
    }

    @Watch('value')
    private onChange(): void {
        this.internalValue = this.value;
    }
}
